import { produce } from 'immer';
import { extractError } from 'app/lib/error';
import type {
    DataDrivenTriggerCandidates,
    GetDataDrivenTriggerCandidatesFailure
} from 'app/lib/types/server';
import type { TypedReduxActionOutcomes } from 'app/store/storeTypes';
import { GET_DATA_DRIVEN_TRIGGER_CANDIDATES_ACTION_TYPE } from './types.js';

export type ExecutionTriggerStateSlice = {
    entityId: null | string;
    isLoading: boolean;
    error: null | GetDataDrivenTriggerCandidatesFailure;
    options: null | DataDrivenTriggerCandidates['entries'];
};
export const INITIAL_STATE: ExecutionTriggerStateSlice = {
    entityId: null,
    isLoading: false,
    error: null,
    options: null
};

export const executionTriggerReducer = produce((draft, action: TypedReduxActionOutcomes) => {
    switch (action.type) {
        case GET_DATA_DRIVEN_TRIGGER_CANDIDATES_ACTION_TYPE.STARTED:
            draft.entityId = action.payload.outputNode;
            draft.isLoading = true;
            draft.error = null;
            draft.options = null;
            break;
        case GET_DATA_DRIVEN_TRIGGER_CANDIDATES_ACTION_TYPE.SUCCEEDED:
            draft.options = action.payload.entries;
            break;
        case GET_DATA_DRIVEN_TRIGGER_CANDIDATES_ACTION_TYPE.REJECTED:
        case GET_DATA_DRIVEN_TRIGGER_CANDIDATES_ACTION_TYPE.FAILED:
            draft.error = extractError(action.payload);
            break;
        case GET_DATA_DRIVEN_TRIGGER_CANDIDATES_ACTION_TYPE.ENDED:
            draft.isLoading = false;
            break;
        default:
    }
}, INITIAL_STATE);
